import { fork, all } from 'redux-saga/effects'

import { sagas as logSagas } from '@arch-log/webapp.modules/log/sagas'
import { sagas as productSagas } from '@arch-log/webapp.modules/product/sagas'
import { sagas as projectSagas } from '@arch-log/webapp.modules/project/sagas'
import { sagas as projectProductSagas } from '@arch-log/webapp.modules/project.product/sagas'

export function* sagas() {
  yield all([
    fork(logSagas),
    fork(projectSagas),
    fork(projectProductSagas),
    fork(productSagas),
  ])
}
